<div
  class="accordian-all-page app-work-order-card-wrapper"
  [class.cursor-pointer]="clickable"
  [ngClass]="customClass"
  (click)="onCardClick($event)"
>
  <div class="row align-items-center">
    <!-- Left / Main Card Area -->
    <div class="col-md-11 cursor-pointer overflow-scrolling">
      <div class="pt-2 pb-3 ps-4 pe-4">
        <div class="d-flex justify-content-between align-items-center w-100 flex-direction-sm">
          
          <!-- Left Sub-column: Dates, Title & Amount Chips -->
          <div class="w-49 bottom-sm-1" (click)="onTitleClick($event)">
            <div class="product-heading">
              <!-- Issue Date & Due Date -->
              <p class="mb-0 issue-date">
                {{ resolvedStartDate | dateFormat }}
                <span class="red ms-2" *ngIf="resolvedDeliveryDate">
                  Due On {{ resolvedDeliveryDate | dateFormat }}
                </span>
              </p>

              <!-- Order Name -->
              <div class="position-relative tooltip-relative">
                <p class="mb-0 supplier-name text-truncate cursor-pointer" [title]="rawOrderName">
                  {{ orderNameDisplay }}
                </p>
                <div class="position-absolute tooltip-amount" *ngIf="rawOrderName?.length > 25">
                  <div class="custom-tooltip">
                    {{ rawOrderName }}
                  </div>
                </div>
              </div>

              <!-- Amount Badges / Progress Chips -->
              <div class="d-flex align-items-center mt-2 flex-direction-sm flex-wrap gap-1">
                <!-- Yellow Dot: Budget -->
                <div class="draft-badge ms-0 total-budget-badge nowrap" *ngIf="resolvedBudget">
                  <span class="status-dot yellow-dot"></span>
                  {{ resolvedBudget | divide : '0.00' }}
                </div>

                <!-- Blue Dot: Total / Received -->
                <div class="draft-badge recieved-badge nowrap" *ngIf="resolvedTotal">
                  <span class="status-dot blue-dot"></span>
                  {{ resolvedTotal | divide : '0.00' }}
                </div>

                <!-- Red Dot: Due -->
                <div class="draft-badge due-badge nowrap" *ngIf="resolvedDue">
                  <span class="status-dot red-dot"></span>
                  {{ resolvedDue | divide : '0.00' }}
                </div>

                <!-- Green Dot: Progress Percentage -->
                <div class="draft-badge flag-badge nowrap" *ngIf="resolvedProgress">
                  <span class="status-dot green-dot"></span>
                  {{ resolvedProgress | number : '1.2-2' }}%
                </div>

                <!-- Custom Badges Slot -->
                <ng-content select="[badges]"></ng-content>
              </div>
            </div>
          </div>

          <!-- Right Sub-column: Customer, Payment Status & Order Status -->
          <div class="w-49 d-flex align-items-center justify-content-between">
            
            <!-- Customer Column (Supports custom projected menu or standard text) -->
            <div class="customer-team-status-effect customer-name-width" *ngIf="showCustomerColumn">
              <ng-content select="[customerColumn]"></ng-content>
              <div class="product-heading" *ngIf="!hasCustomCustomerColumn">
                <h2 class="font-bold">CUSTOMER</h2>
                <div class="position-relative tooltip-relative">
                  <p class="inv-date m-0 customer-name-width text-truncate" [title]="rawCustomerName">
                    {{ customerNameDisplay }}
                  </p>
                  <div class="position-absolute tooltip-amount" *ngIf="rawCustomerName && rawCustomerName.length > 15">
                    <div class="custom-tooltip">
                      {{ rawCustomerName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Payment Status Column -->
            <div class="">
              <div class="product-heading">
                <h2 class="font-bold">PAYMENT STATUS</h2>
                <div class="draft-badge status-btn" [ngClass]="paymentStatusClass">
                  {{ paymentStatusDisplay }}
                </div>
              </div>
            </div>

            <!-- Order Status Dropdown Column -->
            <div class="customer-team-status-effect" (click)="$event.stopPropagation()">
              <app-status-badge
                label="ORDER STATUS"
                [status]="resolvedOrderStatus"
                xPosition="before"
                (statusChange)="onSelectStatus($event)"
              ></app-status-badge>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Right 3-Dots Action Menu Column -->
    <div class="col-md-1 grey-background-arrow dots-btn" *ngIf="showActionMenu">
      <div class="p-15 text-end top-sm-0">
        <div class="d-flex align-items-center justify-content-end justify-content-md-center">
          <app-action-menu headerText="Actions" xPosition="before">
            <ng-container *appHasAccess="accessPermission">
              <app-action-menu-item *ngIf="showEditAction" icon="edit" (clicked)="onEdit($event)">
                Edit
              </app-action-menu-item>
              <app-action-menu-item *ngIf="showCloneAction" icon="clone" (clicked)="onClone($event)">
                Clone
              </app-action-menu-item>
              <app-action-menu-item *ngIf="showDeleteAction" icon="delete" (clicked)="onDelete($event)">
                Delete
              </app-action-menu-item>
            </ng-container>
            <!-- Extra Actions Slot -->
            <ng-content select="[extraActions]"></ng-content>
          </app-action-menu>
        </div>
      </div>
    </div>

  </div>
</div>
